module.exports = __webpack_public_path__ + "images/emoji/dress.886e7182e842e2bc2fad.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/dress.png
// module id = n0kO
// module chunks = 14